import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import { WCAG } from "rytm-wcag"
import { windowUpdate } from './shared/common'
import { buildMasonry, destroyMasonry } from './shared/masonry'
import { buildOwl, destroyOwl } from './shared/owlcarousel'
// controllers
import Controller from './controllers/Controller'
import CategoryMenuController from './controllers/CategoryMenuController'
// views
import View from './views/View'

const routes = {
  'default': {
    controller: Controller,
    view: View
  },
  'category_menu': {
    controller: CategoryMenuController,
    view: null
  },
}

const aswapProps = {
  animationTimeHide: 600,
  animationTimeShow: 800,
  preloadOnHover: false,
  cacheOn: true,
  routes,
  trace,
}
const aswapEvents = {
  onViewSwapComplete: () => {
    windowUpdate()
    buildMasonry()
    buildOwl()
    WCAG.onViewChanged()
    RytmWebflow.showUp.rebuild()
  },
  onViewHide: () => {
    WCAG.dialogCloseAll()
    RytmWebflow.showUp.hide()
  },
  onViewHidden: () => {
    destroyMasonry()
    destroyOwl()
  }
}

export const initASwap = () => {
  RytmWebflow.aswap.init(aswapProps, aswapEvents)
  // push current URL to asHistory
  RytmWebflow.aswap.dispatcher.asHistory.push(window.location.pathname)
}